import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { SERVER_URL } from "../config";

interface Clinic {
  id: string;
  clinicName: string;
  address?: string;
  phone?: string;
  region: string;
  clinicCode: string;
  createdAt: string;
  updatedAt: string;
}

const ClinicsPage: React.FC = () => {
  const [clinics, setClinics] = useState<Clinic[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchClinics = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("No auth token found. Please log in as an admin.");
        }

        const response = await fetch(`${SERVER_URL}/api/clinic/`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch clinics.");
        }

        const data = await response.json();
        setClinics(data);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchClinics();
  }, []);

  if (loading) return <p>Loading clinics...</p>;
  if (error) return <p>{error}</p>;
  if (!clinics.length) return <p>No clinics found.</p>;

  return (
    <div className="all-clinics-page">
      <h1 className="all-clinics-title">All Clinics</h1>
      <table className="clinics-table">
        <thead>
          <tr>
            <th>Clinic Name</th>
            <th>Region</th>
            <th>Address</th>
            <th>Phone</th>
            <th>Clinic Code</th>
            <th>Created</th>
          </tr>
        </thead>
        <tbody>
          {clinics.map((clinic) => (
            <tr key={clinic.id} className="clinics-table-row">
              <td>
                <Link
                  to={`/clinic/${clinic.id}`}
                  state={{ clinic }} // Passing data here
                  className="clinic-link"
                >
                  {clinic.clinicName}
                </Link>
              </td>
              <td>{clinic.region}</td>
              <td>{clinic.address || "N/A"}</td>
              <td>{clinic.phone || "N/A"}</td>
              <td>{clinic.clinicCode}</td>
              <td>{new Date(clinic.createdAt).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ClinicsPage;
